import React, { useContext } from 'react';
import { useTranslate } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import { QuickAppointmentContext } from '../../Context';
import { shouldDisplayVehicleType } from '../../VehicleConstants';
import useStyles from '../styles';

const Vehicle = () => {
  const translate = useTranslate();
  const { vehicleData } = useContext(QuickAppointmentContext);
  const classes = useStyles();

  const renderVehiclePreview = () => {
    const { inputMethodType } = vehicleData;
    const type = shouldDisplayVehicleType() && vehicleData.type;
    if (vehicleData.license || vehicleData.vin) {
      const color = vehicleData.license?.color || vehicleData.vin?.color;
      return (
        <Typography className={classes.typography} variant="caption">
          {[
            color,
            vehicleData.license?.license_plate_number || vehicleData.vin?.vin,
            vehicleData.license?.license_plate_state,
            type ? `(${type})` : null,
          ]
            .filter((e) => e)
            .join(' ')}
        </Typography>
      );
    }

    const { color } = vehicleData[inputMethodType];
    return (
      <Typography className={classes.typography} variant="caption">
        {[
          color,
          vehicleData[inputMethodType].year,
          vehicleData[inputMethodType].make,
          vehicleData[inputMethodType].model,
          type ? `(${type})` : null,
        ]
          .filter((e) => e)
          .join(' ')}
      </Typography>
    );
  };

  if (!vehicleData) {
    return (
      <div className={classes.main}>
        <Typography className={classes.typography} variant="caption">
          None selected
        </Typography>
      </div>
    );
  }

  return (
    <div className={classes.main}>
      {renderVehiclePreview()}
      <div style={{ display: 'flex' }}>
        {vehicleData.photo_filenames?.map((filename) => {
          const source = `https://zippity.s3.amazonaws.com/vehicle/${filename}`;
          return (
            <img
              src={source}
              alt={translate('resources.vehicle.fields.photo_filenames')}
              className={classes.thumbnails}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Vehicle;
